import React, { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../../Pagination";

const DeletedFormFieldGroup = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  fieldGroupLoader,
  formDeletedFieldGroup,
  softDeleteRestoreGlobalFormFieldGroup,
  pageNumberDeleted,
  itemsPerPageDeleted,
  formDeletedFieldGroupCount,
  getDeletedGlobalFormFieldGroup,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(formDeletedFieldGroupCount / itemsPerPageDeleted);

  useEffect(() => {
    getDeletedGlobalFormFieldGroup(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 575 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {fieldGroupLoader ? (
           <PageLoader/>
          ) : formDeletedFieldGroup?.length === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"From field group not deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Category Label
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>
                      Category Name
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 3)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {formDeletedFieldGroup?.map((fieldGroup, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{fieldGroup?.categoryLabel}</td>
                      <td className="text-capitalize">
                        {fieldGroup?.categoryName}
                      </td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreGlobalFormFieldGroup(
                              fieldGroup?._id,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={formDeletedFieldGroupCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedFormFieldGroup;
